import AuthService from '@/services/auth.service';
import UserService from "@/services/user.service";
import router from "@/router";

const authPersistent = JSON.parse(localStorage.getItem('authPersistent'));
const initialState = authPersistent ? authPersistent : {
    loggedIn: false,
    user: null,
    token: null,
    permissions: [],
    role: null
};

export const auth = {
    namespaced: true,
    state: {
        ...initialState,
        usersForTargetRole: new Map(),
    },
    actions: {
        login({commit}, data) {
            return AuthService.login(data).then(
                data => {
                    commit('loginSuccess', data);
                    return Promise.resolve(data);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        register({commit}, data) {
            return AuthService.register(data).then(
                data => {
                    commit('registerSuccess', data);
                    return Promise.resolve(data);
                },
                error => {
                    commit('registerFailure', data);
                    return Promise.reject(error);
                }
            );
        },
        verification({commit}, data) {
            return AuthService.verification(data).then(
                data => {
                    commit('loginSuccess', data);
                    return Promise.resolve(data);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        getPin({commit}, data) {
            return AuthService.getPin(data).then(
                data => {
                    commit('phoneSuccess', data);
                    return Promise.resolve(data);
                },
                error => {
                    commit('phoneFailure', data);
                    return Promise.reject(error);
                }
            );
        },
        verifyForgetPassword({commit}, data) {
            return AuthService.verifyForgetPassword(data).then(
                data => {
                    commit('loginSuccess', data);
                    return Promise.resolve(data);
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error);
                }
            );
        },
        logout({commit}) {
            commit('logout');
            router.push('/login')
        },
        updateMe({commit}, data) {
            return AuthService.updateMe(data).then(
                data => {
                    commit('updateMe', data)
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        getMe({commit}) {
            return AuthService.getMe().then(
                data => {
                    commit('getMe', data)
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        getPermissions({ commit, dispatch }) {
            AuthService.getRoles().then(
                roles => {
                    let permissions = [];
                    for (const role of roles) {
                        permissions = permissions.concat(role.permissions)
                    }
                    commit('setPermissions', permissions)
                    commit('setRole', roles[0].name)
                },
                () => {
                    dispatch('alert/show', {
                        'color': 'danger',
                        'message': 'خطا در دریافت اطلاعات دسترسی، لطفا دوباره وارد حساب خود شوید'
                    }, { root: true })
                    dispatch('logout')
                }
            )
        },
        // TODO: Merge with student / teacher modules
        listUsersForRoles({ commit }, role_name_or_id) {
            UserService.listUsersByRole(role_name_or_id).then(
                users => {
                    commit('setUsersForTargetRole', users)
                },
                error => {
                    return Promise.reject(error)
                }
            )
        }
    },
    mutations: {
        loginSuccess(state, data) {
            data.user.phone = data.user.phone?.replace('+98', '0')
            state.loggedIn = true;
            state.user = data.user;
            state.token = data.token;
            localStorage.setItem('authPersistent', JSON.stringify(state));
        },
        registerSuccess(state, data) {
            state.token = data.token;
            localStorage.setItem('authPersistent', JSON.stringify(state));
        },
        registerFailure(state) {
            state.token = null;
            localStorage.setItem('authPersistent', JSON.stringify(state));
        },
        phoneSuccess(state, data) {
            state.token = data.token;
            localStorage.setItem('authPersistent', JSON.stringify(state));
        },
        phoneFailure(state) {
            state.token = null;
            localStorage.setItem('authPersistent', JSON.stringify(state));
        },
        updateMe(state, data) {
            state.loggedIn = true;
            data.phone = data.phone?.replace('+98', '0')
            state.user = data;
            localStorage.setItem('authPersistent', JSON.stringify(state));
        },
        getMe(state, data) {
            state.loggedIn = true;
            data.phone = data.phone?.replace('+98', '0')
            state.user = data;
            localStorage.setItem('authPersistent', JSON.stringify(state));
        },
        loginFailure(state) {
            state.loggedIn = false;
            state.user = null;
            localStorage.setItem('authPersistent', JSON.stringify(state));
        },
        logout(state) {
            state.loggedIn = false;
            state.user = null;
            state.token = null;
            localStorage.removeItem('authPersistent');
        },
        setPermissions(state, permissions) {
            state.permissions = permissions
            localStorage.setItem('authPersistent', JSON.stringify(state));
        },
        setRole(state, role) {
            state.role = role
            localStorage.setItem('authPersistent', JSON.stringify(state));
        },
        setUsersForTargetRole(state, users) {
            state.usersForTargetRole = new Map()
            for (const entity of users) {
                state.usersForTargetRole.set(entity.id, entity)
            }
        }
    }
};